import { render, staticRenderFns } from "./removeAccount.vue?vue&type=template&id=07127d1b&scoped=true&"
import script from "./removeAccount.vue?vue&type=script&lang=js&"
export * from "./removeAccount.vue?vue&type=script&lang=js&"
import style0 from "./removeAccount.vue?vue&type=style&index=0&id=07127d1b&scoped=true&lang=css&"
import style1 from "./removeAccount.vue?vue&type=style&index=1&id=07127d1b&scoped=true&lang=css&"
import style2 from "./removeAccount.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07127d1b",
  null
  
)

export default component.exports